import { isExternalUrl } from "./cookieConsentUtils";
import { AUDIO_HOSTS, VIDEO_HOSTS } from "./gateThirdPartyHtml";

export const EMBED_TYPE_ORDER = ["video", "audio", "live_chat", "maps", "forms", "ai_assistant", "images", "web_content"];

const MAP_HOSTS = /google\.[a-z.]+\/maps|maps\.google\.|maps\.app\.goo\.gl|goo\.gl\/maps|openstreetmap\.org|bing\.com\/maps|mapbox\.com|arcgis\.com/i;
const FORM_HOSTS = /docs\.google\.com\/forms|forms\.gle|typeform\.com|jotform\.com|forms\.office\.com|forms\.microsoft\.com|hsforms\.(com|net)|share\.hsforms|surveymonkey\.com|tally\.so|formstack\.com|cognitoforms\.com|wufoo\.com/i;
const AI_HOSTS = /chatbase\.co|botpress\.(cloud|com)|bpcontent\.cloud|voiceflow\.com|landbot\.io|typebot\.(io|co)|chatgpt\.com|chat\.openai\.com|copilotstudio\.microsoft\.com|botsonic\.com|sitegpt\.ai|docsbot\.ai|customgpt\.ai|dante-ai\.com|denser\.ai|mendable\.ai|kapa\.ai|interfaces\.zapier\.com|poe\.com/i;

const classifyUrl = (url) => {
  const value = String(url || "");
  if (VIDEO_HOSTS.test(value)) return "video";
  if (AUDIO_HOSTS.test(value)) return "audio";
  if (AI_HOSTS.test(value)) return "ai_assistant";
  if (MAP_HOSTS.test(value)) return "maps";
  if (FORM_HOSTS.test(value)) return "forms";
  return "web_content";
};

const mediaSources = (node) => [
  node.getAttribute("src"),
  node.getAttribute("poster"),
  ...Array.from(node.querySelectorAll("source, track")).map((child) => child.getAttribute("src")),
].filter(Boolean);

const htmlEmbedTypes = (html, types) => {
  if (!html || typeof DOMParser === "undefined") return;
  const root = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html").body.firstElementChild;
  if (!root) return;
  root.querySelectorAll("iframe").forEach((node) => types.add(classifyUrl(node.getAttribute("src"))));
  root.querySelectorAll("video, audio").forEach((node) => {
    if (mediaSources(node).some(isExternalUrl)) types.add(node.tagName === "AUDIO" ? "audio" : "video");
  });
  root.querySelectorAll("img").forEach((node) => {
    if (isExternalUrl(node.getAttribute("src"))) types.add("images");
  });
};

const collectElements = (source, found = [], seen = new Set()) => {
  if (!source || typeof source !== "object" || seen.has(source)) return found;
  seen.add(source);
  if (typeof source.element_type_name === "string") found.push(source);
  Object.values(source).forEach((value) => {
    if (value && typeof value === "object") collectElements(value, found, seen);
  });
  return found;
};

export const getEmbedTypes = (init = window?.objInit) => {
  const types = new Set();
  const elements = collectElements([init?.elements, init?.lightBoxes]);
  elements.forEach((element) => {
    const kind = element.element_type_name.toLowerCase();
    if (kind === "video") types.add("video");
    else if (kind === "audio") types.add("audio");
    else if (kind === "web url") types.add(classifyUrl(element.value?.video_link));
    else if (kind === "image" && !element.file_url && isExternalUrl(element.value?.gif_link)) types.add("images");
    else if (kind === "html text") htmlEmbedTypes(element.value?.html_text, types);
  });
  htmlEmbedTypes(init?.tlb?.opt_in?.custom_text, types);
  if (window?.is_chat_enabled === "true" && window?.chat_link) types.add("live_chat");
  return EMBED_TYPE_ORDER.filter((type) => types.has(type));
};

export const formatEmbedList = (types, names, locale) => {
  const labels = (types || []).map((type) => names?.[type]).filter(Boolean);
  if (!labels.length) return "";
  try {
    return new Intl.ListFormat(locale || "en", { style: "long", type: "conjunction" }).format(labels);
  } catch (error) {
    return labels.join(", ");
  }
};
